import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=3ce969aa&scoped=true&"
import script from "./Factura.vue?vue&type=script&lang=js&"
export * from "./Factura.vue?vue&type=script&lang=js&"
import style0 from "./Factura.vue?vue&type=style&index=0&id=3ce969aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce969aa",
  null
  
)

export default component.exports